import '../../styles/FactReviewBanner.css';

export default function FactReviewBanner({ onDismiss, dismissing }) {
    return (
        <div className="fact-review-banner" role="region" aria-label="Fact review guidance">
            <div className="fact-review-banner-content">
                <h4>Please review each fact before generating documents.</h4>
                <p>
                    Facts are extracted by AI from the source documents. Reviewing each one
                    — including the citation — helps catch incorrect extractions before
                    they flow into the HPI and diagnosis.
                </p>
            </div>
            <button
                className="fact-review-banner-dismiss"
                type="button"
                onClick={onDismiss}
                disabled={dismissing}
            >
                {dismissing ? 'Dismissing...' : 'Got it'}
            </button>
        </div>
    );
}
